import React from 'react';
const FAQS = [{
  q: '¿Qué es exactamente A.R.M.O.N.Y.?',
  a: 'Un bundle de preparación digital — no asesoría médica. Cuatro recursos que trabajan en secuencia: método completo, recurso de recuperación emocional, guion de consulta, y línea de tiempo visual de 90 días.'
}, {
  q: '¿Cómo recibo el bundle?',
  a: 'Entrega inmediata por email después de la compra. Cuatro recursos digitales descargables, accesibles desde cualquier dispositivo.'
}, {
  q: '¿Sustituye una consulta con cirujano?',
  a: 'No. A.R.M.O.N.Y. está diseñado precisamente para complementarla — para que llegues a la consulta con claridad y preguntas correctas, no a improvisar.'
}, {
  q: '¿Y si después no me sirve?',
  a: 'Garantía completa de 14 días. Si en dos semanas A.R.M.O.N.Y. no te ha aportado claridad real, te devolvemos el 100% — sin trámite adicional.'
}];
export function FAQ() {
  return <section className="section" data-id="element-18">
      <h2 className="section-h2" data-id="element-19">Preguntas, consideradas.</h2>

      <div className="faq-list" data-id="element-20">
        {FAQS.map((f, idx) => <details key={idx} className="faq-item" open={idx === 0} data-id="element-21">
            <summary className="faq-summary" data-id="element-22">
              <span data-id="element-23">{f.q}</span>
              <span className="faq-plus" aria-hidden="true" data-id="element-24">
                +
              </span>
            </summary>
            <p className="faq-answer" data-id="element-25">{f.a}</p>
          </details>)}
      </div>
    </section>;
}